import { __extends } from "tslib";
import { GetEventStreamRequest, GetEventStreamResponse } from "../models/models_0";
import { deserializeAws_restJson1GetEventStreamCommand, serializeAws_restJson1GetEventStreamCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetEventStreamCommand = /** @class */ (function (_super) {
    __extends(GetEventStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetEventStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetEventStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "PinpointClient";
        var commandName = "GetEventStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: GetEventStreamRequest.filterSensitiveLog,
            outputFilterSensitiveLog: GetEventStreamResponse.filterSensitiveLog,
        };
        if (typeof logger.info === "function") {
            logger.info({
                clientName: clientName,
                commandName: commandName,
            });
        }
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetEventStreamCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1GetEventStreamCommand(input, context);
    };
    GetEventStreamCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1GetEventStreamCommand(output, context);
    };
    return GetEventStreamCommand;
}($Command));
export { GetEventStreamCommand };
//# sourceMappingURL=GetEventStreamCommand.js.map